import {
  CREATE_IRA_APPLICATION_ACCOUNT_NUMBER,
  CREATE_IRA_APPLICATION_ACCOUNT_NUMBER_SUCCESS,
  CREATE_IRA_APPLICATION_ACCOUNT_NUMBER_ERROR,
  UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER,
  UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER_SUCCESS,
  UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER_ERROR,
  CREATE_IRA_APPLICATION_FUNDING_AMOUNT,
  CREATE_IRA_APPLICATION_FUNDING_AMOUNT_SUCCESS,
  CREATE_IRA_APPLICATION_FUNDING_AMOUNT_ERROR,
  UPDATE_IRA_APPLICATION_FUNDING_AMOUNT,
  UPDATE_IRA_APPLICATION_FUNDING_AMOUNT_SUCCESS,
  UPDATE_IRA_APPLICATION_FUNDING_AMOUNT_ERROR,
  CREATE_IRA_APPLICATION_TRANSFER_TYPE,
  CREATE_IRA_APPLICATION_TRANSFER_TYPE_SUCCESS,
  CREATE_IRA_APPLICATION_TRANSFER_TYPE_ERROR,
  UPDATE_IRA_APPLICATION_TRANSFER_TYPE,
  UPDATE_IRA_APPLICATION_TRANSFER_TYPE_SUCCESS,
  UPDATE_IRA_APPLICATION_TRANSFER_TYPE_ERROR,
  CREATE_IRA_APPLICATION_ACCOUNT_TYPE,
  CREATE_IRA_APPLICATION_ACCOUNT_TYPE_SUCCESS,
  CREATE_IRA_APPLICATION_ACCOUNT_TYPE_ERROR,
  UPDATE_IRA_APPLICATION_FUNDING_TYPE_ERROR,
  UPDATE_IRA_APPLICATION_FUNDING_TYPE_SUCCESS,
  UPDATE_IRA_APPLICATION_FUNDING_TYPE,
  CREATE_IRA_APPLICATION_FUNDING_TYPE_ERROR,
  CREATE_IRA_APPLICATION_FUNDING_TYPE_SUCCESS,
  CREATE_IRA_APPLICATION_FUNDING_TYPE,
  UPDATE_IRA_APPLICATION_ACCOUNT_TYPE,
  UPDATE_IRA_APPLICATION_ACCOUNT_TYPE_SUCCESS,
  UPDATE_IRA_APPLICATION_ACCOUNT_TYPE_ERROR,
  CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE,
  CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_SUCCESS,
  CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_ERROR,
  UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE,
  UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_SUCCESS,
  UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_ERROR,
  DELETE_IRA_APPLICATION_FUNDING,
  DELETE_IRA_APPLICATION_FUNDING_SUCCESS,
  DELETE_IRA_APPLICATION_FUNDING_ERROR,
} from './iraFundingActionConstants';

export const createIraApplicationAccountNumber = (payload) => ({
  type: CREATE_IRA_APPLICATION_ACCOUNT_NUMBER,
  payload,
});

export const createIraApplicationAccountNumberSuccess = (payload) => ({
  type: CREATE_IRA_APPLICATION_ACCOUNT_NUMBER_SUCCESS,
  payload,
});

export const createIraApplicationAccountNumberError = (payload) => ({
  type: CREATE_IRA_APPLICATION_ACCOUNT_NUMBER_ERROR,
  payload,
});

export const updateIraApplicationAccountNumber = (payload) => ({
  type: UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER,
  payload,
});

export const updateIraApplicationAccountNumberSuccess = (payload) => ({
  type: UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER_SUCCESS,
  payload,
});

export const updateIraApplicationAccountNumberError = (payload) => ({
  type: UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER_ERROR,
  payload,
});

export const createIraApplicationFundingAmount = (payload) => ({
  type: CREATE_IRA_APPLICATION_FUNDING_AMOUNT,
  payload,
});

export const createIraApplicationFundingAmountSuccess = (payload) => ({
  type: CREATE_IRA_APPLICATION_FUNDING_AMOUNT_SUCCESS,
  payload,
});

export const createIraApplicationFundingAmountError = (payload) => ({
  type: CREATE_IRA_APPLICATION_FUNDING_AMOUNT_ERROR,
  payload,
});

export const updateIraApplicationFundingAmount = (payload) => ({
  type: UPDATE_IRA_APPLICATION_FUNDING_AMOUNT,
  payload,
});

export const updateIraApplicationFundingAmountSuccess = (payload) => ({
  type: UPDATE_IRA_APPLICATION_FUNDING_AMOUNT_SUCCESS,
  payload,
});

export const updateIraApplicationFundingAmountError = (payload) => ({
  type: UPDATE_IRA_APPLICATION_FUNDING_AMOUNT_ERROR,
  payload,
});

export const createIraApplicationTransferType = (payload) => ({
  type: CREATE_IRA_APPLICATION_TRANSFER_TYPE,
  payload,
});

export const createIraApplicationTransferTypeSuccess = (payload) => ({
  type: CREATE_IRA_APPLICATION_TRANSFER_TYPE_SUCCESS,
  payload,
});

export const createIraApplicationTransferTypeError = (payload) => ({
  type: CREATE_IRA_APPLICATION_TRANSFER_TYPE_ERROR,
  payload,
});

export const updateIraApplicationTransferType = (payload) => ({
  type: UPDATE_IRA_APPLICATION_TRANSFER_TYPE,
  payload,
});

export const updateIraApplicationTransferTypeSuccess = (payload) => ({
  type: UPDATE_IRA_APPLICATION_TRANSFER_TYPE_SUCCESS,
  payload,
});

export const updateIraApplicationTransferTypeError = (payload) => ({
  type: UPDATE_IRA_APPLICATION_TRANSFER_TYPE_ERROR,
  payload,
});

export const createIraApplicationFundingType = (payload) => ({
  type: CREATE_IRA_APPLICATION_FUNDING_TYPE,
  payload,
});

export const createIraApplicationFundingTypeSuccess = (payload) => ({
  type: CREATE_IRA_APPLICATION_FUNDING_TYPE_SUCCESS,
  payload,
});

export const createIraApplicationFundingTypeError = (payload) => ({
  type: CREATE_IRA_APPLICATION_FUNDING_TYPE_ERROR,
  payload,
});

export const updateIraApplicationFundingType = (payload) => ({
  type: UPDATE_IRA_APPLICATION_FUNDING_TYPE,
  payload,
});

export const updateIraApplicationFundingTypeSuccess = (payload) => ({
  type: UPDATE_IRA_APPLICATION_FUNDING_TYPE_SUCCESS,
  payload,
});

export const updateIraApplicationFundingTypeError = (payload) => ({
  type: UPDATE_IRA_APPLICATION_FUNDING_TYPE_ERROR,
  payload,
});

export const deleteIraApplicationFunding = (payload) => ({
  type: DELETE_IRA_APPLICATION_FUNDING,
  payload,
});

export const deleteIraApplicationFundingSuccess = (payload) => ({
  type: DELETE_IRA_APPLICATION_FUNDING_SUCCESS,
  payload,
});

export const deleteIraApplicationFundingError = (payload) => ({
  type: DELETE_IRA_APPLICATION_FUNDING_ERROR,
  payload,
});

export const createIraApplicationAccountType = (payload) => ({
  type: CREATE_IRA_APPLICATION_ACCOUNT_TYPE,
  payload,
});

export const createIraApplicationAccountTypeSuccess = (payload) => ({
  type: CREATE_IRA_APPLICATION_ACCOUNT_TYPE_SUCCESS,
  payload,
});

export const createIraApplicationAccountTypeError = (payload) => ({
  type: CREATE_IRA_APPLICATION_ACCOUNT_TYPE_ERROR,
  payload,
});

export const updateIraApplicationAccountType = (payload) => ({
  type: UPDATE_IRA_APPLICATION_ACCOUNT_TYPE,
  payload,
});

export const updateIraApplicationAccountTypeSuccess = (payload) => ({
  type: UPDATE_IRA_APPLICATION_ACCOUNT_TYPE_SUCCESS,
  payload,
});

export const updateIraApplicationAccountTypeError = (payload) => ({
  type: UPDATE_IRA_APPLICATION_ACCOUNT_TYPE_ERROR,
  payload,
});

export const createIraApplicationPaymentDeliveryType = (payload) => ({
  type: CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE,
  payload,
});

export const createIraApplicationPaymentDeliveryTypeSuccess = (payload) => ({
  type: CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_SUCCESS,
  payload,
});

export const createIraApplicationPaymentDeliveryTypeError = (payload) => ({
  type: CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_ERROR,
  payload,
});

export const updateIraApplicationPaymentDeliveryType = (payload) => ({
  type: UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE,
  payload,
});

export const updateIraApplicationPaymentDeliveryTypeSuccess = (payload) => ({
  type: UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_SUCCESS,
  payload,
});

export const updateIraApplicationPaymentDeliveryTypeError = (payload) => ({
  type: UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_ERROR,
  payload,
});
